// ============================================================
// Empty-States — Erster Start, Keine Treffer im Zeitraum
// ============================================================

import { Icon } from '../icons';
import { CO, readableOnBrand } from '../theme';
import { useApp, useEntries } from '../store';
import { period } from '../aggregator';

export function EmptyFirstStart() {
  const { setRoute } = useApp();
  const brand = CO.sidebar;
  const T = readableOnBrand(brand);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 440 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: '#eef5ef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 18px',
          }}
        >
          <Icon name="down" color={brand} size={30} />
        </div>
        <div style={{ fontSize: 20, fontWeight: 700 }}>Noch keine Daten vorhanden</div>
        <div style={{ fontSize: 13.5, color: CO.muted, lineHeight: 1.6, marginTop: 8 }}>
          Importiere deine Spielhistorie als JSON-Datei, um Einsatz, Auszahlung und Nettoergebnis
          auszuwerten. Die Verarbeitung erfolgt vollständig lokal in diesem Browser.
        </div>
        <button
          onClick={() => setRoute('datenimport')}
          style={{
            marginTop: 20,
            padding: '12px 24px',
            border: 'none',
            borderRadius: 10,
            background: brand,
            color: T.fg,
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          JSON importieren
        </button>
      </div>
    </div>
  );
}

export function NoHits() {
  const { periodMode, setPeriodMode, customFrom, customTo, setRoute } = useApp();
  const entries = useEntries();
  const brand = CO.sidebar;
  const T = readableOnBrand(brand);
  const label = period(periodMode, entries, customFrom, customTo).label;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '52vh',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            background: '#f0f2ed',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
          }}
        >
          <Icon name="cal" color={CO.muted} size={26} />
        </div>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Keine Einträge im gewählten Zeitraum</div>
        <div style={{ fontSize: 13, color: CO.muted, lineHeight: 1.6, marginTop: 8 }}>
          Für „{label}" liegen keine Buchungen vor. Wählen Sie einen anderen Zeitraum, um Auswertungen anzuzeigen.
        </div>
        <button
          onClick={() => {
            setPeriodMode('gesamt');
            setRoute('uebersicht');
          }}
          style={{
            marginTop: 18,
            padding: '10px 20px',
            border: 'none',
            borderRadius: 9,
            background: brand,
            color: T.fg,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Auf Gesamtzeitraum zurücksetzen
        </button>
      </div>
    </div>
  );
}
